import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/logo.svg';

export const IconLogo = createIconComponent(Icon);
